import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Title from './Title';
// import Cookies from 'universal-cookie';
// const cookies = new Cookies();
function preventDefault(event) {
    event.preventDefault();
}
function createData(orderInfo) {
    // const orderInfo = cookies.get('orderInfoList');
    if (orderInfo !== undefined) {
            return orderInfo.printStatus
    } else {
        return ('');
    }

}
export default function OrderStatus({ orderInfo }) {
    return (
        <React.Fragment>
            <Title>Current Status</Title>
            <Typography component="p" variant="h4">
                {createData(orderInfo) }
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
                
            </Typography>
            <div>
                <Link color="primary" href="#" onClick={preventDefault}>
                    
                </Link>
            </div>
        </React.Fragment>
    );
}